export default __webpack_public_path__ + "static/media/car2.04737a3b.png";